import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

@Entity('goal')
export class GoalEntity extends BaseEntity {
	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('int', { name: 'year' })
	public year!: number;

	@Column('int', { name: 'month' })
	public month!: number;

	@Column('decimal', {
		name: 'monthlyRevenue',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public monthlyRevenue!: string | null;

	@Column('decimal', {
		name: 'monthlyGP',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public monthlyGp!: string | null;

	@Column('int', { name: 'dailyCalls', nullable: true })
	public dailyCalls!: number | null;

	@Column('int', { name: 'dailyCallDuration', nullable: true })
	public dailyCallDuration!: number | null;

	@Column('int', { name: 'dailyProductiveCalls', nullable: true })
	public dailyProductiveCalls!: number | null;

	@Column('int', { name: 'dailyCustomers', nullable: true })
	public dailyCustomers!: number | null;

	@Column('int', { name: 'dailyLines', nullable: true })
	public dailyLines!: number | null;

	@Column('int', { name: 'dailyLeadVisits', nullable: true })
	public dailyLeadVisits!: number | null;

	@Column('int', { name: 'dailyCustomerVisits', nullable: true })
	public dailyCustomerVisits!: number | null;

	@Column('int', { name: 'monthlyQuotes', nullable: true })
	public monthlyQuotes!: number | null;

	@Column('decimal', {
		name: 'grossProfitMargin',
		nullable: true,
		precision: 5,
		scale: 2,
	})
	public grossProfitMargin!: string | null;

	@Column('int', { name: 'monthlyCustomersClosed', nullable: true })
	public monthlyCustomersClosed!: number | null;

	@Column('int', { name: 'monthlyCustomers', nullable: true })
	public monthlyCustomers!: number | null;

	@Column('decimal', {
		name: 'monthlyGrossProfitMargin',
		nullable: true,
		precision: 5,
		scale: 2,
	})
	public monthlyGrossProfitMargin!: string | null;

	@ManyToOne(() => UserEntity, (user) => user.goals, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
